import axios from "axios";
import Globais, { validateToken } from "../components/Globais";
import { DiagnosticoOperacionalResumo } from "../interfaces/DiagnosticoOperacionalResumo";

export const buscarDiagnosticoOperacionalResumoService = async () => {
  const token = validateToken();

  if (!token) {
    return null;
  }

  const url = `${Globais.DOMINIOBACK}/cota-usuario/diagnostico/resumo`;

  try {
    const response = await axios.get<DiagnosticoOperacionalResumo>(url, {
      headers: { Authorization: token.AuthStr },
    });

    return response.data;
  } catch (error) {
    console.error(error);
    return null;
  }
};
